// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const MultiProfile = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M14.8,17a6.51,6.51,0,1,1,6.51-6.51A6.51,6.51,0,0,1,14.8,17Zm0-12a5.51,5.51,0,1,0,5.51,5.51A5.51,5.51,0,0,0,14.8,5Z" />
            <Path d="M25.09,36a.5.5,0,0,1-.5-.5V25.2a6.37,6.37,0,0,0-6.36-6.37H11.37A6.37,6.37,0,0,0,5,25.2V35.5a.5.5,0,0,1-1,0V25.2a7.37,7.37,0,0,1,7.37-7.37h6.87a7.37,7.37,0,0,1,7.36,7.37V35.5A.5.5,0,0,1,25.09,36Z" />
            <Path d="M28,15.17a4.85,4.85,0,1,1,4.85-4.85A4.86,4.86,0,0,1,28,15.17Zm0-8.71a3.85,3.85,0,1,0,3.85,3.85A3.86,3.86,0,0,0,28,6.46Z" />
            <Path d="M35.5,29.86a.5.5,0,0,1-.5-.5V21.9a4.48,4.48,0,0,0-4.48-4.48h-5a4.44,4.44,0,0,0-2.59.83.5.5,0,0,1-.58-.81,5.44,5.44,0,0,1,3.17-1h5A5.48,5.48,0,0,1,36,21.9v7.46A.5.5,0,0,1,35.5,29.86Z" />
        </G>
    );
};

export default MultiProfile;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/multi-profile/index.js